import { forwardRef } from 'react';
import { ButtonGroup, CancelButton, ConfirmButton, Message, ModalContainer, Overlay } from './style';

const ConfirmModal = forwardRef((props, ref) => {
  return (
    <Overlay>
      <ModalContainer>
        <Message>{props.message}</Message>
        <ButtonGroup>
          <CancelButton onClick={props.onCancel}>{props?.cancelButtonLabel || '研修を続ける'}</CancelButton>
          <ConfirmButton onClick={props.onConfirm}>{props?.confirmButtonLabel || '研修をやめる'}</ConfirmButton>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
})

export default ConfirmModal;
